// /opt/isp_erp/frontend/src/api/warehouse.api.js
import api from './axios';

export const warehouseAPI = {
  // Estadísticas
  getEstadisticas: () => api.get('/warehouse/estadisticas'),
  
  // Equipos
  buscarEquipo: (sn) => api.get(`/warehouse/equipos/buscar/${sn}`),
  getHistorialEquipo: (sn) => api.get(`/warehouse/equipos/${sn}/historial`),
  crearEquipo: (data) => api.post('/warehouse/equipos', data),
  listarEquipos: (params) => api.get('/warehouse/equipos', { params }), // NUEVO: para listar todos los equipos
  
  // Movimientos
  despacharEquipo: (data) => api.post('/warehouse/movimientos/despacho', data),
  instalarEquipo: (sn, customerId, installationId, ticketId) =>
    api.post('/warehouse/movimientos/instalacion', null, {
      params: { sn, customer_id: customerId, installation_id: installationId, ticket_id: ticketId }
    }),
  retirarEquipo: (sn, ticketId, tecnicoId, observaciones) =>
    api.post('/warehouse/movimientos/retiro', null, {
      params: { sn, ticket_id: ticketId, tecnico_id: tecnicoId, observaciones }
    }),
  recepcionEquipo: (data) => api.post('/warehouse/movimientos/recepcion', data),
  transferirEquipo: (data) => api.post('/warehouse/movimientos/transferencia', data),

   // Reingresar a RMA
  reingresarEquipoRMA: async (sn, observaciones) => {
    const response = await api.post('/warehouse/movimientos/reingreso-rma', {
      sn: sn,
      observaciones: observaciones || 'Reingreso desde RMA a inventario'
    });
    return response;
  },

  // Eliminar equipo
  eliminarEquipo: (sn) => api.delete(`/warehouse/equipos/${sn}`),

  // Eliminar material del catálogo
  eliminarMaterial: (materialId) => api.delete(`/warehouse/materiales/${materialId}`),
  
  // Consultas
  getPendientesRetiro: () => api.get('/warehouse/pendientes/retiro'),
  getMovimientos: (params) => api.get('/warehouse/movimientos', { params }), // NUEVO: para listar historial de movimientos
  getEquiposRMA: () => api.get('/warehouse/equipos/rma') // NUEVO: para listar equipos en RMA
};
